module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Tree","commonjs2":"rc-tree","commonjs":"rc-tree","amd":"rc-tree","umd":"rc-tree"}
// module id = 10
// module chunks = 0